import { Component, Input } from '@angular/core';
import { ComplexSubField } from 'src/app/shared/models/credential/personScenarioEvidenceDetails';

@Component({
  selector: 'complex-field-snapshot',
  templateUrl: './complex-field-snapshot.component.html',
  styleUrls: ['./complex-field-snapshot.component.scss'],
})
export class ComplexFieldSnapshotComponent {
  @Input()
  subFields: ComplexSubField[];

  @Input()
  showAllFields: boolean = false;

  get fields(): ComplexSubField[] {
    if (this.showAllFields) {
      return this.subFields;
    }
    //note: this doesn't work right because instead of this.subFields.values being empty/null; it just doesn't exist
    return this.subFields.filter((f) => f.values?.length);
  }
}
